import { render } from "./z-spinner.vue?vue&type=template&id=01644a5c&scoped=true"
const script = {}

import "./z-spinner.vue?vue&type=style&index=0&id=01644a5c&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/academy/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01644a5c"]])

export default __exports__